import { trainingCertificateExtension, trainingCertificateMime, validateTrainingCertificateFile } from './personnelTraining.js';

export function manualDocumentMime(file: File): string | null {
  const mime = trainingCertificateMime(file);
  return mime && ['application/pdf', 'image/jpeg', 'image/png'].includes(mime) ? mime : null;
}

export function manualDocumentExtension(file: File): string {
  const mime = manualDocumentMime(file);
  if (!mime) throw new Error('Seleziona un file PDF, JPEG/JPG o PNG.');
  return trainingCertificateExtension(mime);
}

export async function validateManualDocumentFile(file: File): Promise<string | null> {
  if (!manualDocumentMime(file)) return 'Seleziona un file PDF, JPEG/JPG o PNG.';
  return validateTrainingCertificateFile(file);
}
